import React, { useState, useRef } from 'react';
import InputMask from 'react-input-mask';
import {
    TextField,
    FormControl,
    FormHelperText,
} from '@mui/material';

interface DateInputProps {
    label?: string;
    onChange?: (value: string) => void;
    required?: boolean
}

const DateInput: React.FC<DateInputProps> = ({ label = 'Data', onChange, required }) => {
    const [value, setValue] = useState('');
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');
    const inputRef = useRef<HTMLInputElement>(null);

    const validateDate = (dateStr: string): boolean => {
        if (!dateStr.trim()) return true; // Campo vazio é válido

        const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        const match = dateStr.match(regex);

        if (!match) return false;

        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1;
        const year = parseInt(match[3], 10);

        const date = new Date(year, month, day);

        return (
            date.getFullYear() === year &&
            date.getMonth() === month &&
            date.getDate() === day
        );
    };

    const handleBlur = () => {
        let isValid = validateDate(value);

        if (value === '' || value === '__/__/____') {
            isValid = true
            setValue('');
        };


        if (!isValid) {
            setError(true);
            setHelperText('Data inválida. Use o formato dd/mm/aaaa.');
            // Reforça o foco no input
            setTimeout(() => {
                inputRef.current?.focus();
            }, 0);
        } else {
            setError(false);
            setHelperText('');
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        setValue(val);
        onChange?.(val);
    };

    return (
        <FormControl fullWidth margin="normal" error={error}>
            <InputMask
                mask="99/99/9999"
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
            >
                {(inputProps: any) => (
                    <TextField
                        {...inputProps}
                        label={label}
                        variant="outlined"
                        inputRef={inputRef}
                        error={error}
                        placeholder="dd/mm/aaaa"
                        size="small"
                        required={required}
                    />
                )}
            </InputMask>
            {error && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default DateInput;
